'use client';

import { ArrowForward } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import Button from '@/components/atoms/Button';
import { SectionContainer } from '@/components/layouts/SectionContainer';
import { CTA } from '@/services/types';
import { getImageUrl } from '@/services/utils';

interface CTASectionProps {
  data?: CTA;
}

export default function CTASection({ data }: CTASectionProps) {
  const fallbackData: CTA = {
    id: 1,
    title: 'Liên hệ để hợp tác',
    description:
      'Chúng tôi luôn sẵn sàng hỗ trợ bạn trong việc bắt đầu dự án mới hoặc cung cấp thông tin.',
    buttonText: 'LIÊN HỆ NGAY',
    buttonLink: '/contact',
    backgroundImage: {
      id: 1,
      name: 'cta-background',
      url: '/api/uploads/cta-background.jpg',
      width: 1920,
      height: 600,
    },
  };

  const cta = data || fallbackData;

  return (
    <SectionContainer
      sx={{
        pl: 0,
        pr: 0,
        ...(cta.backgroundImage && {
          backgroundImage: `url(${getImageUrl(cta.backgroundImage)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }),
      }}
    >
      <Box
        component='section'
        id='cta-section'
        data-component='cta-section'
        sx={{
          py: 14,
          background: 'linear-gradient(rgba(6, 6, 6, 0.4), rgba(6, 6, 6, 0.4))',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Box
          sx={{
            maxWidth: '1200px',
            mx: { xs: 2, sm: 4, md: 6, lg: 8 },
            px: { xs: 2, sm: 4, md: 6, lg: 8 },
          }}
        >
          <Box sx={{ maxWidth: '768px' }}>
            <Box sx={{ mb: { xs: 3, sm: 4, md: 6, lg: 8 } }}>
              <Typography
                variant='h1'
                component='h1'
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: '32px', sm: '40px', md: '48px' },
                  lineHeight: 1.2,
                  color: 'white',
                  mb: { xs: 2, sm: 3 },
                }}
              >
                {cta.title}
              </Typography>

              <Typography
                variant='body1'
                sx={{
                  fontSize: { xs: '16px', sm: '18px' },
                  lineHeight: 1.5,
                  color: 'white',
                  opacity: 0.9,
                }}
              >
                {cta.description}
              </Typography>
            </Box>

            <Button
              href={cta.buttonLink}
              variant='primary'
              size='large'
              icon={<ArrowForward />}
              iconPosition='end'
            >
              {cta.buttonText}
            </Button>
          </Box>
        </Box>
      </Box>
    </SectionContainer>
  );
}
